module.exports = __webpack_public_path__ + "media/bootstrap-icons/shift-fill-34e22640.svg";